import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/reset.css';
import './assets/scss/dh.css';
import router from "./router/index"
import http from "./api/http.js";
import api from "./api/api.js";
import './utils/rem' // 引入适配
// 引入 ECharts
import * as echarts from 'echarts'
// 挂载到 Vue 原型
Vue.prototype.$echarts = echarts
//api接口表全局挂载
Vue.prototype.$api = api;
//接口请求全局挂载
Vue.prototype.$http = http;

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
